import React, { useContext } from "react";
import { AditivoProps } from "./types"
import { Button, Card, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SecaoAditivosContext } from "../../../../../../../contexts/SecaoAditivosContext";

export function Aditivo({ aditivo, idx }: AditivoProps) {
  const { abrirModalAditivo, buscarSituacaoAditivo } = useContext(SecaoAditivosContext)

  return <>
    <Card.Header className="border mb-2 align-items-center px-3">
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id="ver-aditivo">Mais informações</Tooltip>}
      >
        <Button size="sm" className="mr-2" onClick={() => abrirModalAditivo?.(aditivo, idx)}>
          <FontAwesomeIcon icon="info-circle" />
        </Button>
      </OverlayTrigger>
      <span><strong>{`${aditivo.descricao_motivo}${buscarSituacaoAditivo?.(aditivo)}`}</strong></span>
    </Card.Header>
  </>
}